import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './workers.intl.json';

export const useWorkersIntl = () => useIntlModule(messages);
